import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WHY_CHOOSE } from "../data";
import { SectionHeading } from "./SectionHeading";

export const WhyChooseUs = ({ onBook }) => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative z-10 py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <SectionHeading
            overline="Why Choose Marez"
            title="A standard of care most shops can't match"
            subtitle="We obsess over the details so your vehicle looks, feels, and smells its absolute best."
          />
          <button
            data-testid="why-quote-btn"
            onClick={onBook}
            className="btn-3d gloss-sweep inline-flex items-center rounded-full bg-[#fafafa] text-[#050505] font-semibold px-7 py-3.5 hover:bg-white"
          >
            Book on Booksy
          </button>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {WHY_CHOOSE.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`why-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              whileHover={{ y: -6 }}
              className={`rounded-2xl border border-white/5 bg-[#111111] p-6 hover:border-white/20 transition-colors duration-300 ${
                i === WHY_CHOOSE.length - 1 ? "sm:col-span-2" : ""
              }`}
            >
              <div className="h-10 w-10 rounded-full bg-white/10 flex items-center justify-center mb-5">
                <Check size={18} className="text-white" />
              </div>
              <h3 className="font-heading text-lg font-semibold tracking-tight text-white">
                {w.title}
              </h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
